import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
// import { ConfigProvider } from "@nutui/nutui-react";
// import en from "@nutui/nutui-react/dist/locales/en-US";
// import enUS from 'antd-mobile/es/locales/en-US';
import en from 'antd-mobile/es/locales/en-US';
import { ConfigProvider } from "antd-mobile";


ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={en}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
